// aria strings are used for accessibility, fallback to English if i18n isn't provided.

const ariaStrings = {
  previous: _TL_('Previous step'),
  current: _TL_('Current step'),
  next: _TL_('Next step'),
};

const tryTranslate = (ariaI18n, key) => (ariaI18n && ariaI18n.getString(key)) || key;

export const getStepStatusAriaLabel = (step, ariaI18n = null) => {
  if (step.isBehind) {
    return tryTranslate(ariaI18n, ariaStrings.previous);
  } else if (step.isSelected || step.containsSelected) {
    return tryTranslate(ariaI18n, ariaStrings.current);
  }
  return tryTranslate(ariaI18n, ariaStrings.next);
};
